import { Dispatch } from "redux";
import { getMySubscriptions } from "./services";
import { SetMySubscriptions } from "./actions";
import { ISubscriptionItem } from "./types";
import { getSearchResultsService } from "../Search/services";
import { IRefinements } from "../Search/types";

export const getMySubscriptionDispatch = (yourUserId: string, callback?: any) => async (dispatch: Dispatch) => {
    const mySubscriptions: any = await getMySubscriptions(yourUserId);
    let tempSubscriptions: ISubscriptionItem[] = [];
    if (!!mySubscriptions) {
        for (const item of mySubscriptions) {
            let options = {
                keyword: item.title,
                numberOfResults: 5,
                pageNumber: 1,
                select: ["Id", "Guid", "Title"]
            } as IRefinements
            let response = await getSearchResultsService(options, false)
            item.results = response.results
            item.total = response.count
            tempSubscriptions.push(item)
        }
    }
    dispatch(SetMySubscriptions(tempSubscriptions, callback));
};

export const setMySubscriptionDispatch = (mySubs: ISubscriptionItem[]) => async (dispatch: Dispatch) => {
    dispatch(SetMySubscriptions(mySubs));
}